/**
 * Settings-specific building blocks. The generic pieces now live in shared
 * modules — `Section` (`./section`), the status/role pill (`./status-pill`),
 * and the accent palette (`../lib/accent`) — and are re-exported here so the
 * settings pages keep their import site. `FieldLabel` is settings-local.
 */

import { Label, Tooltip, TooltipContent, TooltipTrigger } from "@cometchat-ai/ui-dashboard";
import { Info } from "./icons";

import { StatusPill as BaseStatusPill } from "./status-pill";

export { Section } from "./section";
export { accentForKey } from "../lib/accent";

export function FieldLabel({
  htmlFor,
  label,
  hint,
}: {
  htmlFor?: string;
  label: string;
  hint: string;
}) {
  return (
    <div className="mb-2 flex items-center gap-1.5">
      <Label htmlFor={htmlFor} className="text-2sm">
        {label}
      </Label>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="text-muted-foreground">
            <Info className="h-3.5 w-3.5" aria-hidden="true" />
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">{hint}</TooltipContent>
      </Tooltip>
    </div>
  );
}

/** Role pill — filled foreground for admin, muted for member. */
export function RolePill({ role, label }: { role: string; label: string }) {
  return <BaseStatusPill tone={role === "admin" ? "solid" : "neutral"}>{label}</BaseStatusPill>;
}

/** Status pill — green tint for "active", muted for everything else. */
export function StatusPill({ active, label }: { active: boolean; label: string }) {
  return <BaseStatusPill tone={active ? "success" : "neutral"}>{label}</BaseStatusPill>;
}
